import { render, staticRenderFns } from "./ServicePopup.vue?vue&type=template&id=56707182&scoped=true"
import script from "./ServicePopup.vue?vue&type=script&lang=js"
export * from "./ServicePopup.vue?vue&type=script&lang=js"
import style0 from "./ServicePopup.vue?vue&type=style&index=0&id=56707182&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@6.26.3_cache-loader@4.1.0_webpac_ddacfd63a0804571a953918ce6bcb0d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56707182",
  null
  
)

export default component.exports